import React, { forwardRef } from 'react';

import 'react-datepicker/dist/react-datepicker.css';
import { TextField } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form';

import { parseDate, formatDate } from 'common/utils/dates';
import {
    getLocaleEquivalenceForDateFns,
    getDateFormatByLocale,
} from 'common/utils/helpers/multiregion';

const CustomInput = ({
    disabled,
    error,
    fullWidth,
    label,
    onChange,
    onClick,
    value,
}) => (
    <TextField
        {...{ disabled, onClick, onChange, value }}
        autoComplete="off"
        error={Boolean(error)}
        fullWidth={fullWidth}
        helperText={error?.message}
        label={label}
    />
);

const CustomInputRefered = forwardRef((props, ref) => (
    <CustomInput {...props} myForwardedRef={ref} />
));

CustomInputRefered.displayName = 'CustomInputRefered';

CustomInput.propTypes = {
    disabled: PropTypes.bool,
    error: PropTypes.object,
    fullWidth: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    value: PropTypes.string,
};

const InputDatePickerReactHookForm = ({
    control,
    disabled,
    displayFormat = getDateFormatByLocale(),
    fullWidth,
    label,
    maxDate,
    minDate,
    name,
    onChange,
    placeholder,
    readOnly,
}) => {
    const handleChange = (date, onChangeField, onChange) => {
        if (date) {
            const _date = formatDate(date);
            onChangeField(_date);
            if (onChange) onChange(_date);
        }
    };

    return (
        <Controller
            control={control}
            name={name}
            render={({
                field: { onChange: onChangeField, value },
                fieldState: { error },
            }) => (
                <DatePicker
                    customInput={
                        <CustomInputRefered
                            control={control}
                            disabled={disabled}
                            error={error}
                            fullWidth={fullWidth}
                            label={label}
                            name={name}
                        />
                    }
                    dateFormat={displayFormat}
                    dateFormatCalendar="MMMM"
                    disabled={disabled}
                    dropdownMode="select"
                    locale={getLocaleEquivalenceForDateFns()}
                    maxDate={maxDate}
                    minDate={minDate}
                    onChange={(e) => handleChange(e, onChangeField, onChange)}
                    peekNextMonth
                    placeholderText={placeholder}
                    readOnly={readOnly}
                    selected={value ? parseDate(value, 'dd/MM/yyyy') : null}
                    showMonthDropdown
                    showYearDropdown
                />
            )}
        />
    );
};

InputDatePickerReactHookForm.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    displayFormat: PropTypes.string,
    fullWidth: PropTypes.bool,
    label: PropTypes.string,
    maxDate: PropTypes.instanceOf(Date),
    minDate: PropTypes.instanceOf(Date),
    name: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    readOnly: PropTypes.bool,
};

export default InputDatePickerReactHookForm;
